module.exports = __webpack_public_path__ + "static/media/condo.112acb08.svg";